import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-037-growth chart",
  "use": "icon-037-growth chart-usage",
  "viewBox": "0 0 150 150",
  "content": "<symbol viewBox=\"0 0 150 150\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-037-growth chart\"><g><path d=\"m150 146.653h-150v-142.982h3.239v139.742h146.761z\" fill=\"#3a556a\" /><path d=\"m12.05 103.894h20.688v34.315h-20.688z\" fill=\"#985b3f\" /><path d=\"m43.341 90.16h20.688v48.049h-20.688z\" fill=\"#44c4a1\" /><path d=\"m74.633 72.927h20.688v65.282h-20.688z\" fill=\"#e56353\" /><path d=\"m105.946 44.4h20.688v91.499h-20.688z\" fill=\"#27a2db\" /><path d=\"m109.099 21.25-5.55-17.902-16.348 7.99 1.9 3.887 9.264-4.535c-17.448 55.456-81.866 68.154-82.536 68.284l.799 4.319c.669 0 66.664-12.957 85.474-69.947l2.872 9.286z\" fill=\"#3a556a\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/037-growth chart.svg
// module id = 0UYi
// module chunks = 102